import Store from "../utils/Store";
function useAdminPriveleges() {
  var userInfo = Store.useState(function (s) {
    return s.userInfo;
  });
  var hasPrivileges = Array.isArray(userInfo === null || userInfo === void 0 ? void 0 : userInfo.approve_site_sources) && userInfo.approve_site_sources.length !== 0;
  return hasPrivileges;
}
export default useAdminPriveleges;